import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ArrowRight = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="arrow-right"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 15 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.4603 13.7376L3.14568 24.4869C2.42594 25.171 1.25899 25.171 0.539592 24.4869C-0.179864 23.8034 -0.179864 22.6948 0.539592 22.0113L10.5513 12.4998L0.539883 2.98869C-0.179573 2.30489 -0.179573 1.19638 0.539883 0.512853C1.25934 -0.170951 2.42623 -0.170951 3.14598 0.512853L14.4606 11.2623C14.8203 11.6042 15 12.0519 15 12.4998C15 12.9479 14.82 13.3959 14.4603 13.7376Z" />
    </svg>
  );
};
/* eslint-enable max-len */

ArrowRight.defaultProps = {
  className: null,
};

ArrowRight.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ArrowRight;
